import React, { type ReactNode, memo } from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon/types';
import AppsIcon from '@atlaskit/icon/core/apps';
import EditIcon from '@atlaskit/icon/core/edit';
import FilesIcon from '@atlaskit/icon/core/files';
import TaskIcon from '@atlaskit/icon/core/task';
import SpacesIcon from '@atlaskit/icon-lab/core/spaces';

import type { MenuId } from './PlatformNavigationTypes.ts';

type StyledIconComponentProps = {
	icon: { (props: NewCoreIconProps, displayName: string) };
};

const StyledIconComponent = memo(({ icon }: StyledIconComponentProps) => {
	const IconComponent = icon;
	return <IconComponent label="" color="currentColor" spacing="spacious" />;
});

export const platformNavigationIcons: { [key in MenuId]?: ReactNode } = {
	drafts: <StyledIconComponent icon={EditIcon} />,
	templates: <StyledIconComponent icon={FilesIcon} />,
	tasks: <StyledIconComponent icon={TaskIcon} />,
	spaces: <StyledIconComponent icon={SpacesIcon} />,
	apps: <StyledIconComponent icon={AppsIcon} />,
};
